(() => {
  const root=document.querySelector('[id^="MainProduct-"]');
  if(!root)return;
  const motion=matchMedia('(prefers-reduced-motion:reduce)');
  const activeAnimations=new Set();
  function animate(node,keyframes,options){
    const animation=node.animate(keyframes,options);
    activeAnimations.add(animation);
    animation.finished.catch(()=>{}).then(()=>activeAnimations.delete(animation));
    return animation;
  }

  // One outline follows the selected thumbnail; resizing keeps it aligned.
  const slider=root.querySelector('.thumbnail-slider');
  if(!slider)return;
  const thumbs=[...root.querySelectorAll('.thumbnail')];
  const indicator=document.createElement('div');
  indicator.className='sg-thumb-indicator';
  indicator.setAttribute('aria-hidden','true');
  slider.append(indicator);
  function positionIndicator(){
    const selected=thumbs.find(button=>button.getAttribute('aria-current')==='true');
    if(!selected)return;
    const outer=slider.getBoundingClientRect();
    const box=selected.getBoundingClientRect();
    indicator.style.width=box.width+'px';
    indicator.style.height=box.height+'px';
    indicator.style.transform=`translate(${box.left-outer.left-slider.clientLeft+slider.scrollLeft}px,${box.top-outer.top-slider.clientTop+slider.scrollTop}px)`;
    slider.classList.add('sg-thumb-indicator-ready');
  }
  positionIndicator();
  root.addEventListener('sg:gallerychange',positionIndicator);
  new ResizeObserver(positionIndicator).observe(slider);

  // Old and new amounts share an anchor; the LED pulse stays on the parent.
  root.addEventListener('sg:pricechange',event=>{
    root.querySelectorAll('.sg-price-previous').forEach(node=>node.remove());
    root.querySelectorAll('.sg-price-value').forEach(node=>node.getAnimations().forEach(animation=>animation.cancel()));
    if(motion.matches)return;
    const price=root.querySelector('.product__info-container .price');
    const amount=price.querySelector(price.classList.contains('price--on-sale')?'.price-item--sale':'.price__regular .price-item--regular');
    const value=amount.querySelector('.sg-price-value');
    if(!value)return;
    const previous=value.cloneNode(false);
    previous.className='sg-price-previous';
    previous.textContent=event.detail.previous;
    previous.setAttribute('aria-hidden','true');
    amount.append(previous);
    animate(value,[{opacity:0},{opacity:1}],{duration:240,easing:'ease-out'});
    animate(previous,[{opacity:1},{opacity:0}],{duration:240,easing:'ease-out'}).finished.catch(()=>{}).then(()=>previous.remove());
  });

  // A single sequence lights each step and its outgoing connector.
  const steps=root.querySelector('#sg-preview-journey .sg-how-grid');
  const cards=[...steps.querySelectorAll('.sg-how-card')];
  cards.forEach((card,index)=>{
    card.style.setProperty('--sg-step-index',index);
    if(index===cards.length-1)return;
    const connector=document.createElement('span');
    connector.className='sg-step-connector';
    connector.setAttribute('aria-hidden','true');
    card.append(connector);
  });
  let stepObserver;
  if(!motion.matches&&'IntersectionObserver' in window){
    stepObserver=new IntersectionObserver(entries=>{
      if(!entries.some(entry=>entry.isIntersecting))return;
      steps.classList.add('sg-steps-play');
      stepObserver.disconnect();
    },{threshold:.3});
    stepObserver.observe(steps);
  }
  // Reveal description text once as each reading group enters the viewport.
  // Content remains visible without JavaScript, and no effect persists on the body copy.
  const about=root.querySelector('.sg-locker-details');
  let textObserver;
  if(about&&!motion.matches&&'IntersectionObserver' in window){
    const title=about.querySelector('.sg-description-intro-copy>h2');
    const intro=about.querySelector('.sg-description-intro-copy>.sg-locker-intro');
    const groups=[...about.querySelectorAll('.sg-locker-detail-grid>section')];
    textObserver=new IntersectionObserver(entries=>{
      entries.forEach(entry=>{
        if(!entry.isIntersecting)return;
        const block=entry.target;
        textObserver.unobserve(block);
        block.dataset.sgTextRevealed='true';
        const nodes=groups.includes(block)?[...block.querySelectorAll(':scope>h3,:scope>p:not(.product__sku),:scope>ul>li,:scope>ol>li')]:[block];
        nodes.forEach((node,index)=>{
          const delay=(block===intro?110:0)+Math.min(index,6)*65;
          animate(node,[{opacity:0,transform:'translateY(8px)'},{opacity:1,transform:'translateY(0)'}],{duration:block===title?650:480,delay,easing:'cubic-bezier(.2,.7,.25,1)',fill:'backwards'});
        });
        if(block===title)title.classList.add('sg-about-title-lit');
      });
    },{threshold:.15});
    [title,intro,...groups].filter(Boolean).forEach(block=>textObserver.observe(block));
  }
  motion.addEventListener('change',event=>{
    if(!event.matches)return;
    activeAnimations.forEach(animation=>animation.cancel());
    root.querySelectorAll('.sg-price-previous').forEach(node=>node.remove());
    stepObserver?.disconnect();
    textObserver?.disconnect();
    about?.querySelector('.sg-about-title-lit')?.classList.remove('sg-about-title-lit');
    steps.classList.remove('sg-steps-play');
  });
})();
